import { createNamespacedHelpers } from 'vuex';
import { isOption, isSubOption } from 'js/vue/helpers/chargebee/chargebeeUpsellHelpers.js';

const chargebeeUpsellStore = createNamespacedHelpers('chargebeeUpsellStore');
export default {
    data() {
        return {
            sortedSubscriptionItems: [
                'pack_crm_full',
                'pack_crm_discount',
                'pack_crm_free',
                'pack_invoicing_full',
                'pack_management_full',
                'pack_stock_full',
                'pack_support_full',
                'pack_cashflow_starter_full',
                'pack_cashflow_pro_full',
                'pack_cashflow_business_full',
            ],
        };
    },
    computed: {
        ...chargebeeUpsellStore.mapGetters(['getSubscriptionItems']),
        subscriptionItemsToBeDisplayed() {
            return this.getSubscriptionItems
                .filter((addon) => addon.quantity > 0 && addon.item_type !== 'plan')
                .sort((a, b) => {
                    let idA = a.item_price_id.split('_');
                    idA = idA.slice(0, -1);
                    idA = idA.join('_');

                    let idB = b.item_price_id.split('_');
                    idB = idB.slice(0, -1);
                    idB = idB.join('_');
                    return (
                        this.sortedSubscriptionItems.indexOf(idA) -
                        this.sortedSubscriptionItems.indexOf(idB)
                    );
                });
        },
    },
    methods: {
        isOption,
        isFullAddon(item) {
            return ['full', 'removed'].includes(item.status);
        },
        hasTag(item) {
            return item.updatedQuantity !== 0 || !this.isFullAddon(item);
        },
        tagLabel(item) {
            let label;
            const updatedQuantity =
                item.updatedQuantity < 0 ? item.updatedQuantity * -1 : item.updatedQuantity;

            if (this.isFullAddon(item)) {
                if (isSubOption(item)) {
                    label = this.$l10n.n__('option', 'options', updatedQuantity, updatedQuantity);
                } else {
                    label = isOption(item)
                        ? this.$l10n.__('module')
                        : this.$l10n.n__('licence', 'licences', updatedQuantity, updatedQuantity);
                }
            } else {
                const quantity = updatedQuantity > 0 ? updatedQuantity : item.quantity;

                switch (item.status) {
                    case 'free':
                        label = this.$l10n.n__('offerte', 'offertes', quantity, quantity);
                        break;
                    case 'discount':
                        label = this.$l10n.n__('remisée', 'remisées', quantity, quantity);
                        break;
                    case 'modified':
                        label = this.$l10n.__('modification');
                        break;
                }
            }

            return label;
        },
    },
};
